// extracted by mini-css-extract-plugin
export default {"image__container":"ImagesList_image__container__L2eBq"};